import ls from "local-storage";

class ServiceCategory{
    constructor(json){
        this.id=json.id;
        this.name=json.cat_name;
        this.img=json.img;
        this.isAdminMenu=(json.isAdminMenu != null);
        this.type = (json.type != null)?json.type:null;
    }
}

export default ServiceCategory;